
import { getExam, getExamList,getExamByPost} from "../../api/service.js"
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";
import http from "../../api/module";

let that;


if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
  // Firefox 38+ seems having support of enumerateDevicesx
  navigator.enumerateDevices = function (callback) {
    navigator.mediaDevices.enumerateDevices().then(callback);
  };
}
var MediaDevices = [];
var isHTTPs = location.protocol === 'https:';
var canEnumerate = false;

if (typeof MediaStreamTrack !== 'undefined' && 'getSources' in MediaStreamTrack) {
  canEnumerate = true;
} else if (navigator.mediaDevices && !!navigator.mediaDevices.enumerateDevices) {
  canEnumerate = true;
}

var hasMicrophone = false;
var hasSpeakers = false;
var hasWebcam = false;

var isMicrophoneAlreadyCaptured = false;
var isWebcamAlreadyCaptured = false;

export default{
    components:{
      HeadCom,
      FooterCom
    },
    data(){
        return{
          userInfo: {},
          paramObj:{exerciseType:"",catePatentId:"",cateId:""},
          courseCatetoryPatentList:[],
          courseCatetorySubsetList:[],
          exerciseList:[],
          dataSure: false,
          courseIds:'',
          isLogin:false,
          pageSize:50,
          total:0,
          pageNum:1,
          examTypeList:[{name:"全部",value:"",isActive:true},{name:"模拟考试",value:"0"},{name:"练习题库",value:"1"}],
          isJx:false,
          examListHeight:{height:window.innerHeight-130+'px'},
          imgHeight:{height:window.innerHeight-260+'px'},
        }
    },
    created(){
      this.getUserInfo();
      that=this;
      if(localStorage.getItem("enterpriseId")){
       that.isLogin=true;
      }
      that.paramObj.exerciseType=that.$route.query.type;

      that.examTypeList.forEach(function(bObj){
        that.$set(bObj, 'isActive', false);
        bObj.isActive=false;
        if(that.$route.query.type===bObj.value){
          bObj.isActive=true;
        }
      });
      that.getExerciseList();

    },
    methods: {
      getUserInfo() {
        http.getUserInfo().then(data=>{
          if(data.data.code == '200' || data.data.success == true) {
            this.userInfo = data.data.data;
          }else{
            this.$message.error({
              duration: 1000,
              message: data.data.message
            })
          }
        }).catch(error=>{

        })
      },
      //课程子级分类
      getCourseCatetorySubsetList(cateId,event){
        that.paramObj.catePatentId=cateId;
        that.paramObj.cateId ="";
       /* that.paramObj.exerciseType="";*/
        this.courseCatetoryPatentList.forEach(function(cObj){
          cObj.isActive=false;
          if(cateId==cObj.cateId){
            cObj.isActive=true;
          }

        });
       /* if(cateId==""){
          this.courseCatetorySubsetList=[];
          return false;
        }*/
        let url="/exercise/cateExerciseTwo";
        let data={catePatentId:cateId};
        if(cateId==undefined||cateId==""){
          that.getExerciseList();
          this.courseCatetorySubsetList=[]
          return false;
        }
        getExamList(url,data).then(res=>{
          if(res.success){
            this.courseCatetorySubsetList=res.data;
            if( this.courseCatetorySubsetList.length>0){
              this.courseCatetorySubsetList.unshift({cateName:"全部",cateId:"",isActive:true})
            }
            if(that.$route.query.cateId&&event==undefined){
              that.clickCourseCType(that.$route.query.cateId)
            }else{
              that.getExerciseList();
            }
          }else{
            this.$message.error(res.message)
          }
        })
      },
 /*     //试卷列表
      getEnterpriseEmpCourse(){
        let url="home/getEnterpriseEmpCourse";
        getCourseList(url).then(res=>{
          if(res.success){
            that.courseIds=res.data;
            that.getExerciseList();
          }else{
            this.$message.error(res.message)
          }
        })
      },*/
      //试卷列表
      getExerciseList(){
        if($('.examList')!=undefined&&$('.examList').offset()!=undefined&&$('.examList').offset().top!=undefined){
          var staff_top = $('.examList').offset().top-100;
          $('html,body').animate({scrollTop:staff_top},500);
        }
        let url="/exercise/exerciseList";
        var data={
          pageSize:that.pageSize,
          pageNum:that.pageNum,
          catePatentId:that.paramObj.catePatentId,
          cateId:that.paramObj.cateId,
          exerciseType:0
        };
        that.exerciseList=[];
        getExam(url,data).then(res=>{
          if(res.success){
            that.exerciseList=res.data;
            if(!that.exerciseList.length){
              this.dataSure = true;
            }else{
              this.dataSure = false;
            }
            that.total=res.total;
          }else{
            this.$message.error(res.message)
          }
        }).catch(error=>{
          this.$message.error({
            duration: 1000,
            message: "请求失败,请联系管理员!"
          });
        })
      },
      //分页
        currentChange(page){
          this.pageNum=page;
          this.getExerciseList()
        },
        goToExamDetail(examId,courseId){
          that.$router.push({
            path:"/examDetail",
            query:{
              exerciseId:examId,
              courseId:courseId
            }
          });
         /* that.$confirm('测试开始后，会进行实时人脸拍照，请尽量端正坐姿，使面部完全置于拍摄区域内，谢谢您的配合！！！', '考试温馨提示', {
            confirmButtonText: '我知道了，开始测试',
            showCancelButton:false,
            closeOnClickModal:false,
            type: 'warning'
          }).then(() => {
            that.checkDeviceSupport(function () {
              if (hasWebcam == false) {
                that.$message.warning({
                  message: '捕获摄像头失败，请安装摄像头！',
                  duration: 1000
                })
                return false;
              } else {
                let url="/exercise/exerciseDetailVerification";
                let data={exerciseId:examId,courseId:courseId};
                getExam(url,data).then(res=> {
                  if (res.success) {
                    that.$router.push({
                      path:"/examDetail",
                      query:{
                        exerciseId:examId,
                        courseId:courseId
                      }
                    });
                  }else{
                    that.$alert(res.message, '提示', {
                      confirmButtonText: '确定',
                      callback: action => {

                      }
                    });
                  }
                })
              }
            });
          }).catch(() => {
          });*/

      },
      clickExamType(value){
        that.paramObj.exerciseType =value;
        that.examTypeList.forEach(function(bObj){
          that.$set(bObj, 'isActive', false);
          bObj.isActive=false;
          if(value===bObj.value){
            bObj.isActive=true;
          }
        });
        that.getExerciseList();
      },
      clickCourseCType(value){
        that.paramObj.cateId =value;
        that.courseCatetorySubsetList.forEach(function(obj){
          that.$set(obj, 'isActive', false);
          obj.isActive=false;
          if(value==obj.cateId){
            obj.isActive=true;
          }
        });
        that.getExerciseList();
      },
      goCollect(obj){//添加 取消收藏
        var title=obj.collectType==1?"取消收藏":"收藏";
        let url="/exercise/exerciseCollect";
        var data={
          collectType:obj.collectType==1?0:1,
          exerciseId:obj.id,
          courseId:obj.courseId
        };
        getExamByPost(url,data).then(res=>{
          if(res.success){
            this.$message({
              type: 'warning ',
              message: '已'+title,
              duration:1000

            });
            obj.collectType=obj.collectType==1?0:1;
          /*  that.getExerciseList();*/
          }else{
            this.$message.error(res.message)
          }
        })
      /*  this.$confirm('确定要'+title+'吗', '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
          let url="exercise/exerciseCollect";
          var data={
            collectType:obj.collectType==1?0:1,
            exerciseId:obj.id
          };
          getExamByPost(url,data).then(res=>{
            if(res.success){
              that.getExerciseList();
            }else{
              this.$message.error(res.message)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });*/
      },
      //返回上一页
      goBack(){
        this.$router.go(-1)
      },
      checkDeviceSupport(callback) {//检测是否安装摄像头
        if (!canEnumerate) {
          return;
        }
        if (!navigator.enumerateDevices && window.MediaStreamTrack && window.MediaStreamTrack.getSources) {
          navigator.enumerateDevices = window.MediaStreamTrack.getSources.bind(window.MediaStreamTrack);
        }

        if (!navigator.enumerateDevices && navigator.enumerateDevices) {
          navigator.enumerateDevices = navigator.enumerateDevices.bind(navigator);
        }

        if (!navigator.enumerateDevices) {
          if (callback) {
            callback();
          }
          return;
        }

        MediaDevices = [];
        navigator.enumerateDevices(function (devices) {
          devices.forEach(function (_device) {
            var device = {};
            for (var d in _device) {
              device[d] = _device[d];
            }

            if (device.kind === 'audio') {
              device.kind = 'audioinput';
            }

            if (device.kind === 'video') {
              device.kind = 'videoinput';
            }

            var skip;
            MediaDevices.forEach(function (d) {
              if (d.id === device.id && d.kind === device.kind) {
                skip = true;
              }
            });

            if (skip) {
              return;
            }

            if (!device.deviceId) {
              device.deviceId = device.id;
            }

            if (!device.id) {
              device.id = device.deviceId;
            }

            if (!device.label) {
              device.label = 'Please invoke getUserMedia once.';
              if (!isHTTPs) {
                device.label = 'HTTPs is required to get label of this ' + device.kind + ' device.';
              }
            } else {
              if (device.kind === 'videoinput' && !isWebcamAlreadyCaptured) {
                isWebcamAlreadyCaptured = true;
              }

              if (device.kind === 'audioinput' && !isMicrophoneAlreadyCaptured) {
                isMicrophoneAlreadyCaptured = true;
              }
            }

            if (device.kind === 'audioinput') {
              hasMicrophone = true;
            }

            if (device.kind === 'audiooutput') {
              hasSpeakers = true;
            }

            if (device.kind === 'videoinput') {
              hasWebcam = true;
            }

            // there is no 'videoouput' in the spec.

            MediaDevices.push(device);
          });

          if (callback) {
            callback();
          }
        });
      },
      }
}
